module.exports = __webpack_public_path__ + "img/Warning-Icon.d81f762c.svg";